import '@splidejs/splide/dist/css/themes/splide-sea-green.min.css';
import "../elearning-frontend/stylesheets/main.css"

import "@fortawesome/fontawesome-free/js/all"

import { createApp } from "vue"

import store from "../elearning-frontend/stores"
import router from "../elearning-frontend/router"
import App from "../elearning-frontend/App.vue"

import VScrollLock from 'v-scroll-lock'

import VueSplide from '@splidejs/vue-splide'

import VuePlyr from "vue-plyr"
import "vue-plyr/dist/vue-plyr.css"

document.addEventListener("DOMContentLoaded", () => {
  const el = "#elearning-frontend";
  const elearning = document.querySelectorAll(el);
  if (elearning.length > 0) {
    const params = elearning[0].dataset
    window.department_id = params.id
    createApp(App)
      .use(VuePlyr, { plyr: {}})
      .use(VScrollLock)
      .use(VueSplide)
      .use(store)
      .use(router)
      .mount(el)
  }
});
